var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{staticClass:"px-0 pt-0",attrs:{"xs12":""}},[_c('v-card',{staticClass:"dash-list-title mb-2"},[_c('v-card-text',{staticClass:"body-1 text-truncate py-2"},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }